import axios from "axios";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;

export async function submitCustomAgentLead(payload) {
  await axios.post(`${BACKEND_URL}/api/lead-inquiry`, {
    name: payload.name,
    email: payload.email,
    industry: payload.industry,
    monthly_inbound: payload.monthly_inbound,
    primary_channel: payload.primary_channel?.trim() || "website",
  });
}
